// extracted by mini-css-extract-plugin
module.exports = {"root":"CartSidebarView_root__5gpRe","empty":"CartSidebarView_empty__fvfi0","lineItemsList":"CartSidebarView_lineItemsList__StJOa"};